import { useState, useEffect } from 'react';
import Axios from "axios";
import { GetJobRoles, GetCountries, Searchfilter } from '../apiconstants/constants';
import { Link, useLocation } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png";
import ConsultantLayout from '../commonlayouts/consultantlayout';
import Swal from 'sweetalert2';
import {Modal, Button } from 'react-bootstrap';
import Select from 'react-select';
import { useCountry } from '../contexts/countrycodecontext.js';
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 20) + "...";
}

const GetListOfNonHiredCandidates = () => {
  const [offset, setOffset] = useState(0);
  const [selectedCards, setSelectedCards] = useState(
    JSON.parse(localStorage.getItem('selectedCandidates')) || []
  );
  let query = useQuery();
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
  const [selectAll, setSelectAll] = useState(false);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [jobRoles, setJobRoles] = useState([]);
  const [showFilterModal,setShowFilterModal] = useState(false)
  const [hasNoData, setHasNoData] = useState(false);
  const {selectedCountry} = useCountry();
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")
const appliedfilter = localStorage.getItem("candidateNonHiredFilters")
const token = localStorage.getItem("jwtToken");
const roleID = localStorage.getItem("roleID")

if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}

  const [selectedJobRoles, setSelectedJobRoles] = useState([]);
  const [workmodeOptions] = useState([
    { value: "", label: "Select Work Mode" },
    { value: "1", label: "Work from Home" },
    { value: "2", label: "Work from Office" },
    { value: "3", label: "Hybrid" },
  ]);
  const [selectedWorkMode, setSelectedWorkMode] = useState(null);
  const [countries, setCountries] = useState([]);
  // const [selectedCountry, setSelectedCountry] = useState(null);
  const dateFilterOptions = [
    { value: "", label: "Select Date Filter" },
    { value: "Past 7 days", label: "Past 7 days" },
    { value: "Past 30 days", label: "Past 30 days" },
    { value: "This month", label: "This month" },
    { value: "Past 6 months", label: "Past 6 months" },
    { value: "Past 1 year", label: "Past 1 year" }, // Default case
     { value: "Past 2 years", label: "Past 2 years" }, // Default case
      { value: "Past 3 years", label: "Past 3 years" }, 
  ];
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
const safeValue = (value) => value != "null" ? value : " ";

 
  const [filters, setFilters] = useState({
    UserGuid: Guid,
    FullName: "",
    Email: "",
    WorkAuthorizationandValidity: "",
    TechnicalSkill: "",
    PreferLocation: null,
    WorkMode: null,
    jobRoleId: "",
    UpdatedDate: null,
  });

  useEffect(() => {
    localStorage.removeItem('selectedCandidates');
    setSelectedCards([]);
  }, []);
  const updatedData = selectedCards.map((obj) => ({
    fullName: obj.fullName,
    email: obj.email,
    candidatesID: obj.candidatesID,
  }));
  localStorage.setItem('selectedCandidates', JSON.stringify(updatedData));

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allFilteredCandidates = candidateData.map(candidate => ({
        fullName: candidate.fullName,
        email: candidate.email,
        candidatesID: candidate.candidatesID
      }));
      setSelectedCards(allFilteredCandidates);
    } else {
      setSelectedCards([]);
    }
  };

    const handleInputChange = (e) => {
      const { name, value } = e.target;
    
      setFilters((prevFilters) => ({
        ...prevFilters,
        [name]: value, // Updates any input field dynamically
      }));
    };
    
    const handleFilterChange = (selectedOption) => {
      setSelectedDateFilter(selectedOption); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        UpdatedDate: selectedOption.label, // ✅ Store label for API
      }));
    };
    
useEffect(() => {
  GetCandidateList();
  fetchJobRoles();
  fetchCountries();
}, [selectedCountry]); // Fetch data only once when the component mounts

const fetchJobRoles = async () => {
  const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
  try {
      const response = await Axios.get(getApiUrl);
      setJobRoles(response.data);
  } catch (error) {
      console.error("Error fetching job roles", error);
  }
};
const fetchCountries = async () => {
  try {
    const response = await fetch(GetCountries.APIURL,
      { headers: {   
           Authorization: `Bearer ${token}`,  
            "Content-Type": "application/json",  
         } }      
    );
    const json = await response.json();
    
    // Format the countries for react-select
    const countryOptions = json.map((country) => ({
      value: country.countryID, // Assuming each country has a unique ID
      label: country.country, // Adjust based on API response structure
    }));

    setCountries([{ value: "", label: "Select Country" }, ...countryOptions]);
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const handleViewToggle = (type) => {
  setViewType(type);
  setShowIcon(type)
};

const jobRoleOptions = jobRoles.map((item) => ({
  value: item.jobRoleId,
  label: item.jobRole
}));

const getJobRoleName = (id) => {
  const jobRole = jobRoles.find(role => role.jobRoleId == id);
  return jobRole ? jobRole.jobRole : "";
};

const handleCancelSearch = () => {
  setShowFilterModal(false);
};
  const GetCandidateList = async () => {
    setIsLoading(true);
   const savedFilters = localStorage.getItem("candidateNonHiredFilters");
  let payload;

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters);
         parsedFilters.CountryID = selectedCountry;
    setFilters(parsedFilters); // Optional: sync with UI filters

    payload = {
      json: JSON.stringify(parsedFilters),
      type: "nonhired",
    };
  } else {
    // Default payload when no saved filters
    payload = {
      json: JSON.stringify({ UserGuid: Guid, CountryID: selectedCountry }),
      type: "nonhired",
    };
  }
 
      const result =   Axios.post(Searchfilter.APIURL, payload,
      { headers: { Authorization: `Bearer ${token}` }, }
      )
     .then((result) => {
  setIsLoading(false);
  if (Array.isArray(result.data)) {
    setCandidateData(result.data);
  } else {
    setCandidateData([]);
  }
})
.catch((error) => {
        console.log("Error" + error);
      });
  };
  const handleFilterSearch=()=>{
    setShowFilterModal(true);
    }
    const handleJobRoleChange = (selectedOptions) => {
      const jobRolesLabels = selectedOptions.map((opt) => opt.value).join(", "); 
      setFilters((prevFilters) => ({
        ...prevFilters,
        jobRoleId: jobRolesLabels, // ✅ Store as a string
      }));
    };
    
    
    
    const handleWorkModeChange = (selectedOption) => {
      setSelectedWorkMode(selectedOption);
      
      setFilters((prevFilters) => ({
        ...prevFilters,
        WorkMode: selectedOption.label, // ✅ Store label for API
      }));
    };
    
    // const handleCountryChange = (selectedOption) => {
    //   setSelectedCountry(selectedOption);
    
    //   setFilters((prevFilters) => ({
    //     ...prevFilters,
    //     PreferLocation: selectedOption.label, // ✅ Store label for API
    //   }));
    // };
    
    
    const applyFilters = () => {
      const cleanedFilters = {
        ...filters,
        PreferLocation: filters.PreferLocation === "Select Country" ? "" : filters.PreferLocation,
        WorkMode: filters.WorkMode === "Select Work Mode" ? "" : filters.WorkMode,
        UpdatedDate: filters.UpdatedDate === "Select Date Filter" ? "" : filters.UpdatedDate,
        CountryID: selectedCountry ,
      };
    
      // Remove empty values
      let filteredData = Object.fromEntries(
        Object.entries(cleanedFilters).filter(
          ([key, value]) =>
            value !== "" &&
            value !== null &&
            !(Array.isArray(value) && value.length === 0)
        )
      );
          localStorage.setItem("candidateNonHiredFilters", JSON.stringify(cleanedFilters));
      const payload = {
        json: JSON.stringify(filteredData),
        type: "nonhired",
      };
  
      console.log("Sending JSON:", payload);
      Axios
        .post(Searchfilter.APIURL, payload,
        { headers: { Authorization: `Bearer ${token}` }, }
        )
        .then((response) => {
          console.log("Success:", response.data);
          if(response.data == "No Data"){
            setCandidateData([]);
          }
          else {
          setCandidateData(response.data)
          }
          setShowFilterModal(false)
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };
    const handleCardClick = (clickedCard) => {
      const clickedCardID = clickedCard.candidatesID;
  
      setSelectedCards((prevSelectedCards) => {
        const isCardSelected = prevSelectedCards.some((card) => card.candidatesID === clickedCardID);
        let updatedSelectedCards;
        if (isCardSelected) {
          updatedSelectedCards = prevSelectedCards.filter((card) => card.candidatesID !== clickedCardID);
        } else {
          updatedSelectedCards = [...prevSelectedCards, clickedCard];
        }
  
        return updatedSelectedCards;
      });
    };
  useEffect(() => {
  const filteredData = candidateData?.filter(candidate => {
    const lowerSearchTerm = searchTerm?.toLowerCase()?.trim();

    // If no search term
    if (!lowerSearchTerm) {
        return true; 
    }

    // Determine search logic based on operators
    let searchTerms;
    let isAndSearch = false;
  
    if (lowerSearchTerm?.includes(' + ') || lowerSearchTerm?.includes(' and ')) {
        searchTerms = lowerSearchTerm?.split(/\s*\+\s*|\s+and\s+/);
        isAndSearch = true; // ALL terms must match
    } else if (lowerSearchTerm.includes(' or ')) {
        searchTerms = lowerSearchTerm?.split(/\s+or\s+/);
        isAndSearch = false; // At least one term must match
    } else {
        searchTerms = [lowerSearchTerm]; // Treat it as a single phrase
        isAndSearch = false;
    }
  
    // Convert search terms to lowercase and trim spaces
    searchTerms = searchTerms.map(term => term.trim());
  
    // Function to check if a field contains the *entire search term*
    const fieldMatchesTerm = (term) => {
        return [
            candidate.fullName,
            candidate.technicalSkill,
            candidate.jobRoleName,
            candidate.preferLocation,
            candidate.address,
            candidate.profileSummary,
            candidate.workAuthorizationandValidity,
            candidate.email
        ].some(field => field?.toLowerCase()?.includes(term)) ||
        (candidate.experience !== undefined && 
         (candidate.experience?.toString()?.includes(term) || `${candidate.experience} years`?.includes(term)));
    };
  
    // Apply AND / OR search logic
    const matchesSearch = isAndSearch
        ? searchTerms.every(fieldMatchesTerm) // Require all terms to match (AND search)
        : searchTerms.some(fieldMatchesTerm); // At least one term matches (OR search)

    return matchesSearch;
  });
  if (filteredData.length === 0) {
    setHasNoData(true);
    setData([]); // clear the UI
    setPageCount(0);
    return;
  } else {
    setHasNoData(false);
  }
      
    const slice = filteredData.slice(offset, offset + perPage);
    const items = viewType =='grid' ? slice.map((data) => {
      const isSelected = selectedCards.find((card) => card.candidatesID == data.candidatesID) !== undefined;
      return (
        <div className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3" key={data.guid}>
             <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 500, height: 500, borderRadius: 20 }}>
                <div className='card-header' style={{ background: "none", minHeight: 140 }}>
                  <div className='row'>
                    <div className='col-4'>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Profile Pic</Tooltip>)}>
                        <img alt="Profile Photo" src={(data?.photo === "null") || (data.photo === null )?defaultimg : data?.photoURL} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} />
                        {/* <img alt="Profile Photo" src={defaultimg} style={{ height: 80, width: 80, borderRadius: '50%', border: '3px solid #00a7ac' }} /> */}

                      </OverlayTrigger>
                    </div>
                    <div className='col-8'>
                 
                   <Link style={{ float:"right" }} to={"/Employer/ReplicateBenchCandidate?guid=" + data.guid}>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Replicate Candidate</Tooltip>)}>
                        <button style={{ background: "none", border: "none" }}><i className="fa fa-clone mt-2" aria-hidden="true" style={{ fontSize: 14, color: "#00a7ac" }}></i></button>
                      </OverlayTrigger>
                    </Link>
  
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                        <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                      </OverlayTrigger>
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Job Role</Tooltip>)}>
                        <h5 style={{ fontSize: 18 }}>{getJobRoleName(data.jobRole)}</h5>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{minHeight:180}}>
                                 
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                    <p style={{ fontSize: 14, textAlign: 'justify' }}>
                      <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-code" aria-hidden="true"></i>
                      {substring_str(data.technicalSkill)}
                    </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-phone" aria-hidden="true"></i> {data.mobileNumber} </p>
                  </OverlayTrigger>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i> {data.email}</p>
                  </OverlayTrigger>
               
                  {data.workMode!==null && data.workMode!=="null" && (
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Work Mode</Tooltip>)}>
                    <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-home fa-building" aria-hidden="true"></i> {data.workMode} </p>
                  </OverlayTrigger>)}
              
                   {selectedCountry == 2 &&
  data.workAuthorizationandValidity !== null &&
  data.workAuthorizationandValidity !== "null" && (
    <OverlayTrigger
      placement="bottom"
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>
          Current Visa & First US Entry
        </Tooltip>
      )}
    >
      <p style={{ fontSize: 14 }}>
        <i
          style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
          className="fas fa-cogs"
          aria-hidden="true"
        ></i>
        {data.workAuthorizationandValidity}
      </p>
    </OverlayTrigger>
  )
}

</div>
<div className='card-footer text-center' style={{ background: "none" }}>
                  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">select</Tooltip>}>
                    <input type="checkbox" checked={isSelected} onChange={() => handleCardClick(data)} />
                  </OverlayTrigger>
                </div>
                
              </div>
        </div>
      )  })
      :
    
      <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
                              <table className="table" style={{ minWidth: "100%", fontSize: 14 }}>
                                <thead>
                                  <tr>
                                    <th>Full Name</th>
                                    <th>Job Role</th>
                                    <th>Technical Skill</th>
                                    <th>Mobile Number</th>
                                    <th>Email</th>
                                    {/* <th>Country</th> */}
                                    <th>Work Mode</th>
     {selectedCountry == 2 ?    <th style={{}}>  Current Visa & First US Entry</th> : " " }
                                    <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                   {slice?.map((data, index) =>{
                                      const isSelected = selectedCards.find((card) => card.candidatesID === data.candidatesID) !== undefined;
                return ( 
                                    <tr key={index}>
                                      <td>{data.fullName}</td>
                                      <td>{getJobRoleName(data.jobRole)}</td>
                                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                                      <td> {substring_str(data.technicalSkill)}</td>
                                      </OverlayTrigger>
                                      <td>{data.mobileNumber}</td>
                                      <td>{data.email}</td>
                                      {/* <td>{data.preferLocation}</td> */}
                                      <td>{data.workMode}</td>
     {selectedCountry == 2 ?    <td>{safeValue(data.workAuthorizationandValidity)}</td> : " " }
                                     
                                     <td>  
                                     <div style={{ display: "flex", gap: "5px", alignItems: "center" }}> 
                                              <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">select</Tooltip>}>
                    <input type="checkbox" checked={isSelected} onChange={() => handleCardClick(data)} />
                  </OverlayTrigger>
                          </div></td>

                                     </tr>
                                   )})}
                                </tbody>
                              </table>
                            </div>
      
  

    setData(items);
    setPageCount(Math.ceil(filteredData.length / perPage));
  }, [offset, searchTerm,candidateData, perPage,viewType,selectedCards]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setOffset(0); // Reset offset when search term changes to show results from the first page
  };
  
  useEffect(() => {
    localStorage.removeItem('selectedCandidates');
    setSelectedCards([]);
  }, []);

  const handleRefresh=()=>{
    setSearchTerm("")
    setFilters({
      UserGuid: Guid,
      FullName: "",
      Email: "",
      WorkAuthorizationandValidity: "",
      TechnicalSkill: "",
      PreferLocation: null,
      WorkMode: null,
      jobRoleId: "",
      UpdatedDate: null,
    });
      localStorage.removeItem("candidateNonHiredFilters");
    GetCandidateList();
  }

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
      

<div class="responsive-container" >
  <div style={{ display: 'flex', justifyContent:'space-between' }}>
        <div><h2 className="" style={{ color: "#00a7ac", marginLeft: '10px' }}>
    List of Candidates
  </h2></div>
   <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {showIcon === 'grid' && (
                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                                    <button
                                                      className="btn btn-primary mr-3"
                                                      onClick={() => handleViewToggle('list')}
                                                      style={{ backgroundColor: "#00a7ac",marginBottom:40}}
                                                    >
                                                      <i className="fa fa-th-list" style={{color: '#fff', cursor: 'pointer',fontSize:'14px'}}></i>
                                                    </button>
                                                  </OverlayTrigger>
                                                )}
                                                {showIcon === 'list' && (
                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                                                    <button
                                                      className="btn btn-primary mr-3"
                                                      onClick={() => handleViewToggle('grid')}
                                                      style={{ backgroundColor: "#00a7ac",marginBottom:40, }}
                                                    >
                                                      <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer',fontSize:'14px'}}></i>
                                                    </button>
                                                  </OverlayTrigger>
                                                )}
               
            </div>
            </div>
<div style={{display:'flex',justifyContent:'space-between'}}>
<div className='col'>
            <div style={{ float: 'right', display: 'flex', alignItems: 'center' }}>
            
             
          </div>
  </div>

        </div>
        <div>
 
        <div className="row d-flex justify-content-between">
  <div className="col">
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Technical Skill or Email or Role  or Address</Tooltip>
    )}>
      <input
        type="text"
        placeholder="Search by Name or Technical Skill or Email or Role  or Address"
        className="form-control"
        id="searchcss2"
        value={searchTerm}
        onChange={handleSearch}
      />
    </OverlayTrigger>
  </div>

  <div className="col-auto align-self-end">
    
    
    <Link>
     <OverlayTrigger placement="bottom" overlay={(props) => (
          <Tooltip id="tooltip" {...props}>{ appliedfilter == null ? "Apply Filter" : "Filter Applied" }</Tooltip>
        )}>
        <button className="btn btn-primary  mr-3" onClick={handleFilterSearch} style={{height:50}}type="button">
        <i className="fas fa-filter"></i>    { appliedfilter == null ? "Apply Filter" : "Filter Applied" }
        </button>
        </OverlayTrigger>
    </Link>
    <Link>
    <OverlayTrigger placement="bottom" overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Reset</Tooltip>
    )}>
    <button className="btn btn-primary" onClick={handleRefresh} style={{height:50}}type="button">
      <i className="fas fa-sync"></i> Reset Filter
    </button>
    </OverlayTrigger>
    </Link>
  </div>
</div>
     </div>
    
        <hr />
<div style={{float:'right',display:'flex'}}>
  <div>
                <input 
                  type="checkbox" 
                  checked={selectAll} 
                  onChange={handleSelectAll} 
                  style={{ marginRight: '10px' }} 
                />
                <span style={{marginRight: '10px',  color: '#333', }}>Select All</span>
            </div>
            <div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Click to Proceed</Tooltip>)}>
                <Link to="/Employer/ConfigureInitialScreeningTest">
                  <button className="btn btn-primary mb-5" btn-type="button"><i className="fa fa-arrow-right" aria-hidden="true" style={{ color: "#fff", backgroundColor: "#00a7ac" }}></i></button>
                </Link>
              </OverlayTrigger>
              </div>
</div>

{/* table */}
     {isLoading ? (
            <center><LoadingSpinner /></center>
          ) : (
            <>
   {hasNoData ? (
    <div className="pb-5 text-center">
      <img
        title="No Data"
        className="no-data-img"
        alt="no-data-img"
        src={nodataimg}
        style={{ height: 370 }}
      />
    </div>
  ) : (
    <div className="row " style={{marginTop:'105px'}}>
      {data}
    </div>
     
  )}
  
  
            </>
          )}
        {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }
      <Modal show={showFilterModal} style={{ textAlign: 'center'}}  dialogClassName="custom-modal"  onHide={handleCancelSearch}>
        <Modal.Header closeButton>
          <Modal.Title style={{color:"#00a7ac"}}>Filters </Modal.Title>
         </Modal.Header>
        <Modal.Body>
          <div className='row'>
                <div className='col-6'>               
          
              
      {/* <Select
  options={workmodeOptions} // Pass formatted options
  placeholder="Select Work Mode"
  className="mt-3"
  value={workmodeOptions.find(option => option.label === filters.WorkMode) || null} 
    onChange={handleWorkModeChange} // Handle selection
  styles={{
    control: (provided) => ({
      ...provided,
      height: 50,
      borderRadius: 10,
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: "left",
      fontSize: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: "left",
      fontSize: "12px",
    }),
  }}
/> */}
          
                <Select
      options={dateFilterOptions}
      placeholder="Select Date Filter"
      value={dateFilterOptions.find(option => option.label === filters.UpdatedDate) || null}
      onChange={handleFilterChange}
      className="mt-3"
      styles={{
        control: (provided) => ({
          ...provided,
          height: 50,
          borderRadius: 10,
          fontSize: "12px",
        }),
        placeholder: (provided) => ({
          ...provided,
          textAlign: "left",
          fontSize: "12px",
        }),
        singleValue: (provided) => ({
          ...provided,
          textAlign: "left",
          fontSize: "12px",
        }),
      }}
    />
                  <Select
            options={jobRoleOptions}
            isMulti
            placeholder="Select Job Roles"
            className="mt-3"
            value={jobRoleOptions.filter(option => 
              filters.jobRoleId.split(", ").includes(option.value.toString()) // ✅ Convert stored string back to array
            )}
            onChange={handleJobRoleChange}
            styles={{
              control: (provided) => ({
                ...provided,
                height: 115,
                borderRadius: 10,
                fontSize: "12px",
              }),
              placeholder: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
            }}
          />
           </div>
                <div className='col-6'>
             
          <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>   Current Visa & First US Entry</Tooltip>)}>    
             
             <input 
                          placeholder='  Current Visa & First US Entry'
                          type="text"
                          name="WorkAuthorizationandValidity"
                          className="form-control basic-form mt-3 "
                          value={filters.WorkAuthorizationandValidity}
                          onChange={handleInputChange}
                      />
                </OverlayTrigger>
                <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Technical Skills</Tooltip>)}>    
             
             <textarea 
                          placeholder='Technical Skills'
                          type=""
                          min="0"
                          title=''
                          row='5'
                          style={{height:115}}
                          name="TechnicalSkill"
                          value={filters.TechnicalSkill}
                          className="form-control basic-form mt-3 "
                          onChange={handleInputChange}
                      />
                </OverlayTrigger>
           
                </div>
          </div>
         
        </Modal.Body>
        <Modal.Footer style={{marginTop:100}}>
        <Button variant="primary" onClick={handleRefresh}>
      <i className="fas fa-sync" style={{ marginRight: "5px" }}></i> Reset
    </Button>
          <Button variant="primary" onClick={applyFilters}>Apply</Button>
          <Button variant="secondary" onClick={handleCancelSearch}>Cancel</Button>

        </Modal.Footer>
      </Modal>
      </div>
       </div>
    </ConsultantLayout>
  );
}

export default GetListOfNonHiredCandidates;


